import React, { useContext, useState } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useMutation, useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { ref } from 'firebase/storage';
import { Table, Tbody, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const exportPdfCollectionReport = async ({ postData }) => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.post(`/college/reportGeneration/generateTcCc`, postData, {
			responseType: 'blob',
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp.data;
		}
	} catch (e) {
		throw new Error();
	}
};

const getAllMembers = (data) => async () => {
	let { setLoading } = data;
	setLoading(true);

	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/timetable/getTeachersListMaster', {
			params: { ...data },
		});
		if (resp.data.statusCode === 400) {
			setLoading(false);

			throw new Error(resp.data.message || 'API Error');
		} else {
			setLoading(false);
			return resp?.data?.teachersListMaster;
		}
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const MasterTimeTables = ({ onClose }) => {
	const [loading, setLoading] = useState(false);

	const { collegeId } = useContext(FirebaseContext);
	const [state, setState] = React.useState({
		startDate: '',
		endDate: '',
	});

	const { data = [], refetch } = useQuery(['aleeeeelTCCC', collegeId, state?.year, parseInt(state?.fist), parseInt(state?.second), parseInt(state?.third)], getAllMembers({ collegeId, year: state.year, firstYearSem: parseInt(state?.fist), secondYearSem: parseInt(state?.second), thirdYearSem: parseInt(state?.third), setLoading }), { keepPreviousData: true });

	const aproveTcCc = async (data) => {
		const instance = await getAxiosTokenInstance();
		let resp;
		resp = await instance.post('/college/requestAprovals/addToMessageTcCcRequests', {
			collegeId,

			messageData: '',
			checkRole: '',
			action: 'aprove',
			classId: '',
			departmentId: '',
			userId: data?.studentsDetails?.uid,
		});
		if (resp.data.statusCode !== 200) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			refetch();
		}
	};

	const exportPdfMutationDateCollectionReport = useMutation(exportPdfCollectionReport);

	const onTcCc = async (data) => {
		setLoading(false);
		try {
			const link = document.createElement('a');
			link.target = '_blank';
			let postData = {
				collegeId,
				startsNumber: data?.tcNumber,
				userId: data?.studentsDetails?.uid,
				applicationDate: data?.appliedOn,
				leavingDate: data?.dateOfLeaving,
				reasonForLeaving: data?.reasonForLeaving,
				exam: data?.exam,
				leaving: data?.leaving,
				joinedSem: data?.joinedSem,
				signatureDate: data?.aprovedOn,
			};
			link.download = data?.studentsDetails?.name;
			const pdfData = await exportPdfMutationDateCollectionReport.mutateAsync({ postData });
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
			link.click();
		} catch (e) {}
	};

const columns = [
		{
			title: 'Sl No',
			dataIndex: '',
			render: (a, data, i) => <span>{i + 1}</span>,
		},

		{
			title: 'Class Name',
			dataIndex: 'className',
			key: 'className',
		},
		{ title: 'M 1', dataIndex: 'm1', key: 'm1' },
		{ title: 'M 2', dataIndex: 'm2', key: 'm2' },
		{ title: 'M 3', dataIndex: 'm3', key: 'm3' },
		{ title: 'M 4', dataIndex: 'm4', key: 'm4' },
		{ title: 'M 5', dataIndex: 'm5', key: 'm5' },
		{ title: 'T 1', dataIndex: 't1', key: 't1' },
		{ title: 'T 2', dataIndex: 't2', key: 't2' },
		{ title: 'T 3', dataIndex: 't3', key: 't3' },
		{ title: 'T 4', dataIndex: 't4', key: 't4' },
		{ title: 'T 5', dataIndex: 't5', key: 't5' },
		{ title: 'W 1', dataIndex: 'w1', key: 'w1' },
		{ title: 'W 2', dataIndex: 'w2', key: 'w2' },
		{ title: 'W 3', dataIndex: 'w3', key: 'w3' },
		{ title: 'W 4', dataIndex: 'w4', key: 'w4' },
		{ title: 'W 5', dataIndex: 'w5', key: 'w5' },
		{ title: 'H 1', dataIndex: 'h1', key: 'h1' },
		{ title: 'H 2', dataIndex: 'h2', key: 'h2' },
		{ title: 'H 3', dataIndex: 'h3', key: 'h3' },
		{ title: 'H 4', dataIndex: 'h4', key: 'h4' },
		{ title: 'H 5', dataIndex: 'h5', key: 'h5' },
		{ title: 'F 1', dataIndex: 'f1', key: 'f1' },
		{ title: 'F 2', dataIndex: 'f2', key: 'f2' },
		{ title: 'F 3', dataIndex: 'f3', key: 'f3' },
		{ title: 'F 4', dataIndex: 'f4', key: 'f4' },
		{ title: 'F 5', dataIndex: 'f5', key: 'f5' },
	];
	console.log(columns.map((item, index) => `${columns.length * 0.27}%`));

	return (
		<Main title='Master Timetables' width='100%' height='100%'>
			<Header>
				<div></div>
				<div className='flex justify-end'>
				<Button type='excel' tableRef={ref.current}>
					Excel
				</Button>
				<Instruction keyId={'masterTimeTables'}/>
				<Button type='close' onClick={onClose}>
					Close
				</Button>
			</div>
			</Header>
			<Body>
				<div className='flex'>
					<div>
						<Input2 fieldName='Admn Year' className='w-[10vw]' returnKey='year' options={['2020-2021', '2021-2022', '2022-2023', '2023-2024', '2024-2025', '2025-2026', '2026-2027']} type='drop' state={state} setState={setState} />
					</div>
					<div>
						<Input2 fieldName='First Year' returnKey='fist' className='w-[10vw]' options={['1', '2', '3', '4', '5', '6']} type='drop' state={state} setState={setState} />
					</div>
					<div>
						<Input2 fieldName='Second Year' returnKey='second' className='w-[10vw]' options={['1', '2', '3', '4', '5', '6']} type='drop' state={state} setState={setState} />
					</div>
					<div>
						<Input2 fieldName='Third Year' returnKey='third' className='w-[10vw]' options={['1', '2', '3', '4', '5', '6']} type='drop' state={state} setState={setState} />
					</div>
				</div>
				<Table height='auto' width='8000px' className='mt-2'>
					<Thead>
						<Tr>
							
							{columns.map((item, i) => (
								<Th key={i} width={i === 0 ? '40px' : '225px'} index={i} position={i}>
									{item.title}
								</Th>
							))}
						</Tr>
					</Thead>
					<Tbody height='auto' width='100%'>
						{data?.map((item, i) => (
							<Tr key={i} index={i} position={i}>
								{columns.map((col, j) => (
									<Th key={j} index={j} width={j === 0 ? '40px' : '225px'} position={j + 1}>
										{j === 0 ? i + 1 : item[col.dataIndex]}
									</Th>
								))}
							</Tr>
						))}
					</Tbody>
				</Table>
			</Body>
		</Main>
	);
};
